import { MainState } from "./state";
import { getStoreAccessors } from "typesafe-vuex";
import { State } from "../state";

export const getters = {
  hasAdminAccess: (state: MainState) => {
    return (
      state.userProfile &&
      state.userProfile.is_super &&
      state.userProfile.is_active
    );
  },
  loginError: (state: MainState) => state.logInError,
  userProfile: (state: MainState) => state.userProfile,
  userList: (state: MainState) => state.userList,
  token: (state: MainState) => state.token,
  isLoggedIn: (state: MainState) => state.isLoggedIn,
  isLoggedInUser: (state: MainState) => state.isLoggedInUser,
  firstNotification: (state: MainState) =>
    state.notifications.length > 0 && state.notifications[0],
  myLastProject: (state: MainState) => state.myLastProject,
  refreshControl: (state: MainState) => state.refreshControl,
  allIndexes: (state: MainState) => state.allIndexes,
  mobaProjects: (state: MainState) => state.mobaProjects,
  heroSkin: (state: MainState) => state.hero_skin,
  taskLogs: (state: MainState) => state.taskLogs,
  staffInfo: (state: MainState) => state.staff_info,
};

const { read } = getStoreAccessors<MainState, State>("");

export const readHasAdminAccess = read(getters.hasAdminAccess);
export const readIsLoggedIn = read(getters.isLoggedIn);
export const readIsLoggedInUser = read(getters.isLoggedInUser);
export const readLoginError = read(getters.loginError);
export const readToken = read(getters.token);
export const readUserProfile = read(getters.userProfile);
export const readUserList = read(getters.userList);
export const readFirstNotification = read(getters.firstNotification);
export const readMyLastProject = read(getters.myLastProject);
export const readRefreshControl = read(getters.refreshControl);
export const readAllIndexes = read(getters.allIndexes);
export const readMobaProjects = read(getters.mobaProjects);
export const readHeroSkin = read(getters.heroSkin);
export const readTaskLogs = read(getters.taskLogs);
export const readStaffInfo = read(getters.staffInfo);
